import React from 'react';
import moment from 'moment';

function DateText( { value }: { value?: string } ) {
  if ( !value ) return null;
  return (
    <>
      <span>{moment.utc( value ).local().format( 'DD/MM/YYYY' )}</span>
      <br />
      <span className="text--sm">{moment.utc( value ).local().format( 'HH:mm' )}</span>
    </>
  );
}

export default DateText;
